<iss-form-field>
  <iss-label>{{ label || 'Agent' }}</iss-label>
  <wo-agent-input
    [formControl]="control.control"
    [readonly]="readonly"
    [placeholder]="placeholder"
    [locale]="locale"
  />
  <ng-template issFormFieldError let-errors>
    <ng-container *ngIf="errors.required">{{ 'iss-core.error.required' | translate }}</ng-container>
  </ng-template>
</iss-form-field>
